export default function formatToCamelString(string) {
  return string
    .replace(/[^\w\s]/g, '')
    .trim()
    .replace(/^\w/, str => str.toLowerCase())
    .replace(/\s+(\w)/g, (_, str) => str.toUpperCase())
}
